import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import MunicipalityList, { IMunicipality } from '../../molecules/municipality-list/municipality-list';
import AlphabeticalNav, { ALPHABETH } from '../../molecules/alphabetical-nav/alphabetical-nav';
import { IClassNames, makeClassNames } from '../../../utils/styles';

export interface IMunicipalityListIndex {
  municipalityList: IMunicipality[];
}

const DEFAULT_SELECTED_LETTER = 'A';

const getMunicipalityNameList = (municipalityList: IMunicipality[]) => {
  return municipalityList.map((municipality) => municipality.name[0]);
};

const classNames = (): IClassNames =>
  makeClassNames({
    municipalityIndex: 'municipality-index',
  });

const MunicipalityListIndex: React.FC<IMunicipalityListIndex> = ({ municipalityList }) => {
  const cn = classNames();

  const [currentLetter, setCurrentLetter] = useState<string>(DEFAULT_SELECTED_LETTER);

  const wordList = useMemo(() => getMunicipalityNameList(municipalityList), [municipalityList]);
  useEffect(() => {
    ALPHABETH.split('').some((alphabetLetter) => {
      if (wordList.includes(alphabetLetter)) {
        setCurrentLetter(alphabetLetter);
        return true;
      }
      return false;
    });
  }, [wordList]);

  const filteredMunicipalities = useMemo(
    () => municipalityList.sort((a, b) => a.name.localeCompare(b.name)),
    [municipalityList]
  );

  return (
    <div id="list-municipality" className={cn.municipalityIndex}>
      <AlphabeticalNav
        wordList={wordList}
        currentLetter={currentLetter}
        onLetterClick={(letter: string) => setCurrentLetter(letter)} // Will be scrollToTop()
      />
      <MunicipalityList municipalityList={filteredMunicipalities} activeLetter={currentLetter} />
    </div>
  );
};

MunicipalityListIndex.propTypes = {
  municipalityList: PropTypes.arrayOf<IMunicipality>(
    PropTypes.shape({
      ballot: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default MunicipalityListIndex;
